<script>
  import { onDestroy, onMount } from "svelte";
  import { todosModalItemStore } from "../../../modals/TodosModal/stores";
  import UploadsButton from "./UploadsButton.svelte";
  import UploadsModal from "./UploadsModal.svelte";
  import { RESUME_ALLOWED_TYPES } from "./assets";
  import {
    isDraggingFilesStore,
    selectedProjectIdsStore,
    uploadsModalStore,
  } from "./stores";

  const isResumeFileTypes = (e) => {
    const { dataTransfer } = e;
    if (!dataTransfer) return false;

    const items = dataTransfer?.items;
    return (
      items &&
      items.length > 0 &&
      Array.from(items).every((file) =>
        RESUME_ALLOWED_TYPES.includes(file.type)
      )
    );
  };
  const handleDragEnter = (e) => {
    if (!isResumeFileTypes(e)) return;
    e.preventDefault();
    e.stopPropagation();

    uploadsModalStore.set(true);
    isDraggingFilesStore.set(true);
  };

  const handleDragLeave = (e) => {
    if (!isResumeFileTypes(e)) return;
    e.preventDefault();
    e.stopPropagation();

    if (e.relatedTarget === null) {
      isDraggingFilesStore.set(false);
    }
  };

  const handleDragOver = (e) => {
    if (!isResumeFileTypes(e)) return;
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e) => {
    if (!isResumeFileTypes(e)) return;
    e.preventDefault();
    e.stopPropagation();

    isDraggingFilesStore.set(false);
  };

  onMount(() => {
    document.addEventListener("dragenter", handleDragEnter);
    document.addEventListener("dragleave", handleDragLeave);
    document.addEventListener("dragover", handleDragOver);
    document.addEventListener("drop", handleDrop);
    const params = new URLSearchParams(window.location.search);
    const candidateId = params.get("openContactModalWithId", false);
    if (candidateId) {
      todosModalItemStore.set({
        candidateId: candidateId,
        toDoId: null,
      });
      // Update the URL without reloading the page
      params.delete("openContactModalWithId");
      const newUrl = `${window.location.pathname}?${params.toString()}`;
      window.history.replaceState({}, "", newUrl);
    }
    if (window.location.pathname === "/project") {
      const projectId = params.get("projectId");
      if (projectId) {
        selectedProjectIdsStore.set([projectId]);
      }
    }
  });

  onDestroy(() => {
    document.removeEventListener("dragenter", handleDragEnter);
    document.removeEventListener("dragleave", handleDragLeave);
    document.removeEventListener("dragover", handleDragOver);
    document.removeEventListener("drop", handleDrop);
  });
</script>

<UploadsButton />
{#if $uploadsModalStore}
  <UploadsModal />
{/if}
